import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContactingTestId } from "@/hooks";
import { ErrorIcon } from "@/components";
import { Box } from "@gemini/core";
import { Divider, InfoState } from "@gemini/ui";
import { useI18n } from "@/shared/hooks";
export const ContactFormError = ({ close }) => {
    const { t } = useI18n();
    const testId = useContactingTestId("ContactFormTechnicalError");
    return (_jsxs(Box, { display: "flex", alignItems: "center", flexDirection: "column", testId: testId, children: [_jsx(Divider, { marginVertical: "spacing.12", "aria-hidden": "true" }), _jsx(InfoState, { image: ErrorIcon, title: t("contact.form.technical_error.title"), description: t("contact.form.technical_error.description"), startButtonProps: {
                    children: t("contact.form.technical_error.back_button"),
                    onPress: close,
                }, marginVertical: "spacing.12" })] }));
};
